var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inbox"},[_c('a',{staticClass:"inbox-link",attrs:{"href":"/"}},[_c('span',{staticClass:"inbox-number"},[_vm._v(_vm._s(_vm.vuex.stores('getters', 'inbox/countGetters')))]),_c('i',{staticClass:"fas fa-inbox"})])])}
var staticRenderFns = []

export { render, staticRenderFns }